module.exports = __webpack_public_path__ + "images/160_1024.jpg";